
import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4">Our Most Cherished Feedback</h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We're honored to share this heartfelt review from one of our valued clients.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <Card className="bg-gray-50 p-8 rounded-lg relative fancy-border">
            <div className="absolute top-0 right-0 flex -mt-4 -mr-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 text-gold fill-gold" />
              ))}
            </div>
            
            <CardContent className="pt-6">
              <p className="text-gray-700 text-lg mb-8 italic leading-relaxed">
                "After dealing with several cleaning companies who treated my home like just another job, finding Gold Standard Cleaning Group was a breath of fresh air.
                They don't just wipe surfaces — they truly clean every corner with care and precision.
                I no longer find traces of dust behind decor, careless streaks on mirrors, or fabric lint in the bathroom like I used to.
                Their team treats my home with the respect and detail it deserves, and it shows in every room.
                I finally feel like my home is being cared for, not just cleaned.
                Worth every penny for the peace of mind and level of service they deliver."
              </p>
              
              <div className="flex items-center gap-4">
                <div>
                  <p className="font-medium text-navy text-lg">Private Residence</p>
                  <p className="text-gray-500">Valued Client, Gold Standard Cleaning Group</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
